// Copyright (c) 2017 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import customer from './customer';
import isFormValid from './form-validation';
import isFormVisible from './form-visibility';
import pipCode from './pip-code-object';
import pipCodeType from './pip-code-type';
import pipProduct from './pip-product';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    customer,
    isFormValid,
    isFormVisible,
    pipCode,
    pipCodeType,
    pipProduct
});



// WEBPACK FOOTER //
// ./src/pip/pip-code/reducers/index.js